<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Transaksi</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Daftar Pembelian Paket</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tabmateri" data-toggle="tab">Daftar Pembelian Paket</a>                                                
											</li> 

											<!-- <li class="nav-item">
												<a class="nav-link" href="#tabkategori" data-toggle="tab">Kategori</a>                                                
											</li> 
                                             
											<li class="nav-item">
												<a class="nav-link" href="#tabsubject" data-toggle="tab"><span class="med-records">Subject</span></a>
											</li> -->
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Materi Tab -->
										<div id="tabmateri" class="tab-pane fade show active">
                                            
                                            <div class="row mobile_row">
                                                <div class="col-md-12" v-for="(ref) in lsttransaksi" :key="ref.id_sales">
                                                    <!-- {{randomLabel(index)}} -->
                                                    <div class="kt-widget2  box-shadow" >
                                                        <div class="kt-widget2__item " 
                                                         :class="{'kt-widget2__item--warning' : ref.inv_status_nm == 'PENDING' , 'kt-widget2__item--brand' : ref.inv_status == 'PAID', 'kt-widget2__item--danger' : ref.inv_status == 'EXPIRED' }"
                                                          >
                                                            <div class="kt-widget2__info">
                                                                <div class="kt-widget2__checkbox">
                                                                    
                                                                </div>
                                                                
                                                                <a href="#" class="kt-widget2__title">
                                                                    {{ref.nama_paket}}
                                                                </a>
                                                                <a href="#" class="kt-widget2__username">
                                                                    No Invoice {{ref.external_id}}<br>
                                                                    Tanggal Beli {{ref.purchase_date}}
                                                                </a>
                                                                <a href="#" class="kt-widget2__username" v-if="ref.expired_date">
                                                                    <span class=" text-info">Expired Date {{ref.expired_date}}</span>
                                                                </a>
                                                                <br>
                                                                <a href="#" :class="{'btn-label-warning' : ref.inv_status_nm == 'PENDING' , 'btn-label-brand' : ref.inv_status == 'PAID', 'btn-label-danger' : ref.inv_status == 'EXPIRED' }" class="btn btn-bold dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                                                    {{ref.inv_status_nm}}
                                                                </a>
                                                                <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right" x-placement="bottom-end" style="position: absolute; transform: translate3d(180px, 40px, 0px); top: 0px; left: 0px; will-change: transform;">
                                                                    <ul class="kt-nav">

                                                                        <li class="kt-nav__item" v-if="ref.inv_status != 'EXPIRED'">
                                                                            <a @click="goToInvoice(ref)"  class="kt-nav__link">
                                                                                <i class="kt-nav__link-icon fas fa-book"></i> 
                                                                                <span class="kt-nav__link-text">Invoice</span>
                                                                            </a>
                                                                        </li>
                                                                        <li class="kt-nav__item" v-if="ref.inv_status == 'PAID'">
                                                                            <a @click="mulaiBelajar(ref)" class="kt-nav__link">
                                                                                <i class="kt-nav__link-icon fas fa-eye"></i> 
                                                                                <span class="kt-nav__link-text">Mulai Belajar</span>
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

											<div class="card card-table mb-0 notmobile_menu">
												<div class="card-body">

                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" @click.prevent="goToBeliPaket()">Beli Paket</a>
                                                    </div>
													<div class="table-responsive">
                                                        <table id="tblMateri" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-center">No Invoice</th>
                                                                    <th class="">Nama Paket</th>
                                                                    <th class="text-ceter">Tanggal Pembelian</th>
                                                                    <th class="text-center">Batas Pembayaran</th>
                                                                    <th class="text-center">Status</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lsttransaksi" :key="ref.id_sales">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.external_id }}</td>
                                                                    <td>{{ ref.nama_paket }}</td>
                                                                    <td>{{ ref.purchase_date }}</td>
                                                                    <td >{{ ref.expired_date }}</td>
                                                                    <td class="text-center">
                                                                        <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.inv_status_nm == 'PENDING' , 'bg-success-light' : ref.inv_status == 'PAID', 'bg-danger-light' : ref.inv_status == 'EXPIRED' }">{{ref.inv_status_nm}}</span>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn v-if="ref.inv_status != 'EXPIRED'" class="btn btn-sm bg-success-light" depressed small @click="goToInvoice(ref)">
                                                                           Invoice
                                                                        </v-btn>
                                                                        <v-btn  v-if="ref.inv_status == 'PAID'" color="btn btn-sm bg-info-light" depressed small @click="mulaiBelajar(ref)">
                                                                           Mulai Belajar
                                                                        </v-btn>
                                                                    </td>
                                                                  
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Materi Tab -->
										
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->
</div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery';
// import moment from "moment";

export default {
    components: {
        Sidebar
    },
	name: 'Materi',
    data() {
        return {
            lsttransaksi: [],
            lstsubdtlmateri: [],
            lstsubject: [],
            subdtlmateri: {
                id_judul: '',
                nama_judul: '',
                // hak_akses: '',
                tanggal_materi: '',
                kategori: '',
                subject: '',
                tipe_coach: '',
                nama_coach: '',
                youtube_id: '',
                url_file: '',
                fg_publish:''
            },
            lstmateri: [],
            // materi:{
            //     id_materi: '',
            //     nama_materi: '',
            // },
            lstsubmateri: [],
            // submateri: {
            //     id_sub_materi: '',
            //     id_materi: '',
            //     nama_sub_materi: '',
            // },
            lsttypecoach: [
                {id: '1', text: 'Master Coach'},
                {id: '2', text: 'Super Coach'},
                {id: '3', text: 'Coach'},
                {id: '4', text: 'Siswa'},
            ],
            lststspublish: [
                {id: '1', text: 'Aktif'},
                {id: '0', text: 'Tidak Aktif'}
            ], 
            labelBox: [
                "brand", "warning","danger","success","primary"
            ],
            curlabel:''
        }
    },
    created: function () {
        // this.getAllMateri();
        this.getAll();
        // this.getAllSub();
    },  

    methods: {
        
        randomLabel : function(idx){
            // this.curindex = (this.curindex==4)?0:this.curindex+1;
            // this.curlabel = this.labelBox[this.curindex];
            this.curlabel = 'kt-widget2__item--'+this.labelBox[(idx%4)+1];
            // console.log(this.curlabel);
        },
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        goToBeliPaket(){
            this.$router.push({name:'siswa-paket-belajar'}); 
        },

        
        goToInvoice: function (ref) {
            // console.log(ref.inv_id);
            localStorage.setItem("idPaket",  ref.id_sales); 
            if(parseInt(ref.price) >0)
                this.$router.push({name:'siswa-paket-belajar-invoice'});//, params: {id: res.data.data}}); 
            else
                this.$router.push({name:'siswa-paket-belajar-invoice-gratis'});//, params: {id: res.data.data}}); 
                
			// this.$router.push({name:'siswa-paket-belajar-invoice', params: {id: ref.id_sales}}); 
        },
        
        mulaiBelajar: function (ref) {
            this.$router.push({name:'siswa-paket-saya-detail', params: {idUser: localStorage.getItem('idUser'), idPaket: ref.id_paket, idPaketSales: ref.id_sales}}); 
        },

        getAll: function () {
            axios.get('api/transaksi/'+localStorage.getItem('idUser'))
                .then(res => {
                    // console.log(res.data);
                    this.lsttransaksi = res.data.data;
                    // this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Siswa/Transaksi/index.vue